import { useState, useEffect } from 'react'

import { SingleValueChart } from '@/components/ui'
import { InsightCardWidth, InsightConfigurationType } from '@/types/dashboard-types'

import { DrilldownLink } from './DrilldownLink'

const SingleValueDisplay = ({
  value,
  width,
  drilldownConfiguration,
}: {
  value: number
  width: InsightCardWidth
  drilldownConfiguration?: InsightConfigurationType
}) => {
  const [isAnimating, setIsAnimating] = useState(false)
  const formattedValue = new Intl.NumberFormat().format(value)

  useEffect(() => {
    setIsAnimating(true)
    const timer = setTimeout(() => setIsAnimating(false), 300)
    return () => clearTimeout(timer)
  }, [value])

  const fontSizeMap: Record<InsightCardWidth, string> = {
    tiny: '[&_span]:text-[20cqw] [&_span]:leading-none',
    mini: '[&_span]:text-[15cqw] [&_span]:leading-none',
    small: '[&_span]:text-[15cqw] [&_span]:leading-none',
    medium: '[&_span]:text-[15cqw] [&_span]:leading-none',
    large: '[&_span]:text-[15cqw] [&_span]:leading-none',
    full: '[&_span]:text-[15cqw] [&_span]:leading-none',
  }
  const animationClass = isAnimating ? 'opacity-50' : 'opacity-100'
  const className = `text-primary transition-opacity duration-300 ${animationClass} ${fontSizeMap[width] || ''}`

  const content = <SingleValueChart data={formattedValue} className={className} />
  if (drilldownConfiguration) {
    return <DrilldownLink id="svd" configuration={drilldownConfiguration} linkContent={content} />
  }
  return content
}

export default SingleValueDisplay
